import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import http from '../../api';
import { FilledSuccessBar } from '../../components/_DesignSystemWrappers/SuccessBar/FilledSuccessBar';
import { LoginFlowsWrapper } from '../_components/LoginFlowsWrapper/LoginFlowsWrapper';
import messages from './messages';

export function SuspiciousLoginPage() {
  const { token } = useParams();
  const { formatMessage } = useIntl();

  useEffect(() => {
    async function callApi() {
      http.get(`/unsubscribe-suspicious-login/${token}`);
    }
    callApi();
  }, []);

  return (
    <Box sx={{ backgroundColor: 'background.paper' }}>
      <LoginFlowsWrapper title={formatMessage(messages.suspiciousTitle)}>
        <FilledSuccessBar>
          <Typography>
            <FormattedMessage {...messages.suspiciousBody} />
          </Typography>
        </FilledSuccessBar>
      </LoginFlowsWrapper>
    </Box>
  );
}
